<div class="modal fade show " id="model" [hidden]="hideStatus"
  style="padding-right: 4px;display: block;background-color: #5853534d">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit" role="document">
    <div class="modal-content">
      <div class="modal-body px-2 py-0">
        <div class="row treetext">
          <div class="col-12" *ngIf="IsOrderByEnabled === false&&ResourceAssignEnabled===false">
            <div class="row Page-Header">
              <div class="col-8">
                <h6 *ngIf="Addnewsubject" class="HeadContent">Add {{Descriptionvalue}}</h6>
                <h6  *ngIf="Editsubjectflag" class="HeadContent">Edit {{Descriptionvalue}}</h6>
              </div>

              <div class="col-4 d-flex flex-row-reverse">
                <button type="button" class="close" *ngIf="Addform.valid&&tempvariable&&Editsubjectflag" (click)="Closepopup()" style="font-size: 26px;outline: 0;">
                  <span aria-hidden="true">&times;</span></button>
                  <button type="button" class="close" *ngIf="!Addform.valid&&Addnewsubject" (click)="reset()" style="font-size: 26px;outline: 0;">
                    <span aria-hidden="true">&times;</span></button>
                    <button type="button" class="close" *ngIf="Addform.valid&&!tempvariable&&Editsubjectflag" (click)="reset()" style="font-size: 26px;outline: 0;">
                      <span aria-hidden="true">&times;</span></button>
                    <button type="button" class="close" *ngIf="Addform.valid&&Addnewsubject" (click)="Closepopup()" style="font-size: 26px;outline: 0;">
                      <span aria-hidden="true">&times;</span></button>
                      <button type="button" class="close" *ngIf="!Addform.valid&&Editsubjectflag&&!translate" (click)="reset()" style="font-size: 26px;outline: 0;">
                        <span aria-hidden="true">&times;</span></button>
                        <button type="button" class="close" *ngIf="!Addform.valid&&Editsubjectflag&&translate" (click)="reset()" style="font-size: 26px;outline: 0;">
                          <span aria-hidden="true">&times;</span></button>

              </div>
            </div>
            <div class="col-12 p-0 border-bottom headersize">
              <app-breadcrumb [Breadcrumblist]=Breadcrumblist></app-breadcrumb>
            </div>
            <form [formGroup]="Addform">
              <div class="col-12 pt-2" style="height:54vh !important; overflow: auto;overflow-y: auto;width:auto;overflow-x:hidden">
                <div class="row">
                  <div class="col-6 my-1 border-right" *ngIf="subjectById.Language_Ind=='N'">
                    <div class="col-12">
                      <div class="row pt-3">
                        <div class="col-3 text-right pr-0 pt-1">
                          <div class="d-flex  flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Name</div>
                          </div>
                        </div>
                        <div class="col-9 pl-2 text-right">
                          <textarea
                            maxlength="100"
                            formControlName="Subject_Name"
                            class="form-control form-control-sm input-txt">
                          </textarea>
                          <label class="form-check-label maxlength" for="exampleCheck1">
                            Characters {{subjectvaluelength}}/{{subjectMaxlength}}
                          </label>

                        </div>
                        <div class="col-3"></div>
                        <div class="col-9"><label class="Valid1" *ngIf="namevalidate">Name Already Exists</label></div>
                        <div class="col-3"></div>
                        <div class="col-9"><label class="Valid1"
                            *ngIf="_submitted && !Addform.value.Subject_Name">Please Enter Subject
                            Name</label></div>
                      </div>
                    </div>
                    <div hidden class="col-12">
                      <div class="row pt-2">
                        <div class="col-2 text-right pr-0 pt-1"></div>
                        <div class="col-10 pl-2">
                          <div class="form-check">
                            <input type="checkbox" (ngModelChange)="Editformvalidation()" class="form-check-input chk" style="height: 16px;">
                            <label class="form-check-label" for="exampleCheck1">Subject is Language</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row pt-2">
                        <div class="col-3 text-right pr-0 pt-1">
                          <div class="d-flex  flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Status</div>
                          </div>
                        </div>
                        <div class="col-9 pl-2">
                          <select [disabled]="!subjecttree.EditedForm" (ngModelChange)="Editformvalidation()" class="form-control form-control-sm" [(ngModel)]="ngSelect"
                            formControlName="Subject_Status_Type_Code" *ngIf="statusvalidate!=null">
                            <option [disabled]="!subjecttree.EditedForm" class="border-bottom" *ngFor="let s of subjectcode"
                              [value]="s.Subject_Status_Type_Code">{{s.Subject_Status_Type_Code}}</option>
                          </select>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-10"><label class="Valid1"
                            *ngIf="( _submitted && !Addform.value.Subject_Status_Type_Code)">Please
                            Choose Status</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row pt-2">
                        <div class="col-3 text-right pr-0 pt-1 pl-0">
                          <div class="d-flex  flex-row-reverse">
                            <div class="p-0">Description</div>
                          </div>
                        </div>
                        <div class="col-9 pl-2 text-right">
                          <textarea maxlength="4000" (ngModelChange)="Editformvalidation()" formControlName="Description_text" class="form-control input-txt1"
                            id="txtdescription"></textarea>
                            <label class="form-check-label maxlength" for="exampleCheck1">Characters {{Descriptionvaluelength}}/{{DescriptionMaxlength}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 my-1" *ngIf="subjectById.Language_Ind=='N'">
                    <div class="row">
                    <div class="col-12">
                        <div class="text-center" style="font-size: 17px;font-weight: 600;">Translate to {{getcodedescription}}</div>
                    </div>
                    </div>
                    <div class="col-12">
                      <div class="row pt-2">
                        <div class="col-2 text-right pr-0 pt-1"></div>
                        <div class="col-10 pl-2">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input chk"
                              [disabled]="Disbletranslation" [checked]="translate"
                              (click)="Translatecheckbox()" style="height: 16px;">
                            <label class="form-check-label" for="exampleCheck1">Translate</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row pt-2">
                        <div class="col-2 text-right pr-0 pt-1">
                          <div class="d-flex  flex-row-reverse">
                            <div class="p-0">Name</div>
                          </div>
                        </div>
                        <div class="col-10 pl-2 text-right">
                          <textarea maxlength="250" (ngModelChange)="Editformvalidation()" formControlName="Translated_Subject_Name"
                            [disabled]="Disbletranslation" class="form-control form-control-sm input-txt"
                            [ngClass]="{'translate-text':(subjectnamechange==true)}"></textarea>
                            <label class="form-check-label maxlength" for="exampleCheck1">Characters {{Translationvaluelength}}/{{TranslationMaxlength}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row pt-2">
                        <div class="col-2 text-right pr-0 pt-1"></div>
                        <div class="col-10 pl-2">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input chk"
                              [disabled]="!translate" [checked]="bracketscheckbox||this.subjectById.Show_English_Name_Ind=='Y'" (click)="Bracketscheckbox()"
                              style="height: 16px;">
                            <label class="form-check-label" for="exampleCheck1">Show Translated English Name in Brackets</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row pt-2">
                        <div class="col-2 text-right pr-0">
                          <div class="d-flex  flex-row-reverse">
                            <div class="p-0">Status</div>
                          </div>
                        </div>
                        <div class="col-10 pl-2">
                          <select (ngModelChange)="Editformvalidation()" [disabled]="!subjecttree.EditedForm||!translate"class="form-control form-control-sm" [(ngModel)]="ngSelect1"
                            formControlName="Translated_Subject_Subject_Status_Type_Code" *ngIf="statusvalidate!=null">
                            <option  [disabled]="!subjecttree.EditedForm||!translate" class="border-bottom" *ngFor="let s of subjectcode"
                              [value]="s.Subject_Status_Type_Code">{{s.Subject_Status_Type_Code}}</option>
                          </select>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-9" *ngIf="subjectById.Language_Ind=='Y'">
                    <div class="col-12">
                      <div class="row pt-3">
                        <div class="col-2 text-right pr-0 pt-1">
                          <div class="d-flex  flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Name</div>
                          </div>
                        </div>
                        <div class="col-10 pl-2 text-right">

                          <textarea  maxlength="100" formControlName="Subject_Name" (ngModelChange)="Editformvalidation()"
                             (focusout)="NameValidation()"
                            class="form-control form-control-sm input-txt"></textarea>
                            <label class="form-check-label maxlength" for="exampleCheck1">Characters {{subjectvaluelength}}/{{subjectMaxlength}}</label>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-10"><label class="Valid1" *ngIf="namevalidate">Name Already Exists</label></div>
                        <div class="col-2"></div>
                        <div class="col-10"><label class="Valid1"
                            *ngIf="_submitted && !Addform.value.Subject_Name">Please Enter Subject
                            Name</label></div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row pt-2">
                        <div class="col-2 text-right pr-0 pt-1">
                          <div class="d-flex  flex-row-reverse">
                            <div class="p-0 label-red">*</div>
                            <div class="p-0">Status</div>
                          </div>
                        </div>
                        <div class="col-10 pl-2">
                          <select formControlName="Subject_Status_Type_Code" (ngModelChange)="Editformvalidation()" [disabled]="!subjecttree.EditedForm" class="form-control form-control-sm" [(ngModel)]="ngSelect"
                             *ngIf="statusvalidate!=null">
                            <option [disabled]="!subjecttree.EditedForm" class="border-bottom" *ngFor="let s of subjectcode"
                              [value]="s.Subject_Status_Type_Code">{{s.Subject_Status_Type_Code}}</option>
                          </select>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-10"><label class="Valid1"
                            *ngIf="( _submitted && !Addform.value.Subject_Status_Type_Code)">Please
                            Choose Status</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row pt-2">
                        <div class="col-2 text-right pr-0 pt-1 pl-0">
                          <div class="d-flex  flex-row-reverse">
                            <div class="p-0">Description</div>
                          </div>
                        </div>
                        <div class="col-10 pl-2 text-right">
                          <textarea  maxlength="4000"  (ngModelChange)="Editformvalidation()" formControlName="Description_text" class="form-control input-txt1"
                            id="txtdescription"></textarea>
                            <label class="form-check-label maxlength" for="exampleCheck1">Characters {{Descriptionvaluelength}}/{{DescriptionMaxlength}}</label>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-3"></div>
                </div>
                </div>






              <div class="row p-3">
                <div class="col-12">
                  <div class="d-flex justify-content-start">
                    <div class="px-1">

                      <button type="button" [disabled]="!Addform.valid || (Addform.valid&&!tempvariable) || namevalidate" (click)="Add()" class="btn btn-sm bl-btn">Save</button>
                    </div>
                    <div class="px-1">
                      <button type="button"  *ngIf="Addform.valid&&tempvariable&&Editsubjectflag" (click)="Closepopup()" class="btn btn-sm bg-light border">Cancel</button>
                      <button type="button" *ngIf="!Addform.valid&&Addnewsubject" (click)="reset()" class="btn btn-sm bg-light border">Cancel</button>
                      <button type="button" *ngIf="Addform.valid&&!tempvariable&&Editsubjectflag" (click)="reset()" class="btn btn-sm bg-light border">Cancel</button>
                      <button type="button" *ngIf="Addform.valid&&Addnewsubject" (click)="Closepopup()" class="btn btn-sm bg-light border">Cancel</button>
                      <button type="button" *ngIf="!Addform.valid&&Editsubjectflag&&!translate" (click)="reset()" class="btn btn-sm bg-light border">Cancel</button>
                      <button type="button" *ngIf="!Addform.valid&&Editsubjectflag&&translate" (click)="reset()" class="btn btn-sm bg-light border">Cancel</button>

                    </div>
                    <div class="px-1">
                      <button type="button" [disabled]="!subjectById.Subject_Id" (click)="changeDisplayOrder()"
                        class="btn btn-sm bg-light border">Change Topic Display Order</button>
                    </div>
                    <div class="px-1">
                      <button type="button" [disabled]="!subjectById.Subject_Id" (click)="onSubjectParentChange()"
                        class="btn btn-sm bg-light border">Relocate Topic</button>
                    </div>
                    <div class="px-1">
                      <button type="button" (click)="ResourceAssign()"
                        class="btn btn-sm bg-light border">Assign Resource</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-12" *ngIf="IsOrderByEnabled === true">
            <div class="row" *ngIf="SDOInput">
              <div class="col-12">

                <app-subject-display-order (closeAddEditElement)="closeAddEditElement($event)" (onSubjectOrderChangeSucces)="onSubjectOrderChangeSucces($event)"
                  (cancelSubjectOrderChange)="cancelSubjectOrderChange($event)" [SDOInput]="SDOInput">
                </app-subject-display-order>
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="ResourceAssignEnabled === true">
            <div class="row  Page-Header">
              <div class="col-8">
                <h6 class="HeadContent">Resource Assignment</h6>
              </div>
              <div class="col-4 d-flex flex-row-reverse">

                  <div class="px-1">
                    <button type="button" *ngIf="ResourceAssignform"  class="close" (click)="ResourceClosepopup()" style="font-size: 26px;">
                      <span aria-hidden="true">&times;</span></button>
                  </div>
                  <div class="px-1">
                    <button type="button" *ngIf="!ResourceAssignform"  class="close" (click)="ResourceCancel()" style="font-size: 26px;">
                      <span aria-hidden="true">&times;</span></button>
                  </div>
              </div>
            </div>
            <div class="col-12 p-0 border-bottom headersize">
              <app-breadcrumb [Breadcrumblist]=Breadcrumblist></app-breadcrumb>
            </div>
            <app-subject-resource-assignment #one  (closeAddEditElement)="closeAddEditElement($event)"  (ResourcePopup)="ResourcePopup($event)" (DisableButton)="DisableButton($event)" (ResourceCancel1)="ResourceCancel1($event)"
              [ResourceAssignID]="ResourceAssignID" [subjectById]="subjectById"
              [RedirectAssignedresourceId]="RedirectAssignedresourceId"></app-subject-resource-assignment>
            <div class="row p-1">
              <div class="col-12">
                <div class="d-flex">
                  <div class="col-3"></div>
                  <div class="px-1">
                    <button type="button" [disabled]="!ResourceAssignform" (click)="one.Save()" class="btn btn-sm bl-btn">Save</button>
                  </div>
                  <div class="px-1">
                    <button type="button" *ngIf="ResourceAssignform" (click)="ResourceClosepopup()" class="btn btn-sm bg-light border">Close</button>
                    <button type="button" *ngIf="!ResourceAssignform" (click)="ResourceCancel()" class="btn btn-sm bg-light border">Close</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal fade show modal-dialog-centered" id="modelconfirm" *ngIf="resourceclosepopupflag"
  [hidden]="!resourceclosepopupflag" style="padding-right: 4px;display: block;background-color: #5853534d;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header mx-2 p-1">
        <h6 class="modal-title" style="
        font-size: 16px;
        font-weight: 500;" id="relocatedheader">Save Changes</h6>
         <button type="button" class="close" (click)="ResourceClosepopup()" style="font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body py-0" style="
      font-size: 16px;
      font-weight: 500;">
        <div class="row py-2 mx-3 pt-3">
          <div class="col-12">
            <label>Do you want to save changes?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex flex-row-reverse">
              <div class="px-1">
                <button type="button" (click)="ResourceCancel()" class="btn btn-sm bg-light border">Cancel</button>
              </div>
              <div class="px-1">
                <button type="button" (click)="one.Save()" class="btn btn-sm bl-btn">Save</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show" id="model" *ngIf="subjectParentEnable" [hidden]="!subjectParentEnable"
  style="padding-right: 4px;display: block;background-color: #5853534d">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit" role="document">
    <div class="modal-content">


      <div class="modal-body pt-0">
        <div class="row  Page-Header">
          <div class="col-8">
            <h6 class="HeadContent">Relocate Topic</h6>
          </div>
          <div class="col-4 d-flex flex-row-reverse">
              <div class="px-1">
                <button type="button" class="close" (click)="SubjectParentChange()" style="font-size: 26px;outline: 0;">
                  <span aria-hidden="true">&times;</span></button>
              </div>

          </div>
        </div>
        <div class="col-12 d-flex">
          <div class="pl-1 pt-1 headersize">Current Location:</div>
          <div class="pr-1 headersize">
            <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
          </div>
        </div>
        <div class="col-12" *ngIf="subjectParentEnable === true">
          <div class="row" *ngIf="SubjectParentInput">
            <div class="col-12">
              <app-subject-relocate  (closeAddEditElement)="closeAddEditElement($event)" [MajorTopic]="MajorTopic" [Refresh]="Refresh" [SubjectParentInput]="SubjectParentInput"
                (cancelSubjectParentChange)="cancelSubjectParentChange($event)"
                (onSubjectParentChangeSucces)="onSubjectParentChangeSucces($event)"></app-subject-relocate>
            </div>
          </div>
        </div>
    </div>
    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-centered" id="model" *ngIf="Conformationpopupflag"
  [hidden]="!Conformationpopupflag" style="padding-right: 4px;display: block;background-color: #5853534d;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header  mx-2 p-1">
          <h6 class="modal-title" style="
          font-size: 16px;
          font-weight: 500;" id="relocatedheader">Save Changes</h6>
      </div>

      <div class="modal-body py-0"  style="
      font-size: 16px;
      font-weight: 500;">
        <div class="row py-2 mx-3 pt-3">
          <div class="col-12">
            <label>Do you want to save changes?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex flex-row-reverse">

              <div class="px-1">
                <button type="button" (click)="Conformationpopup()" class="btn btn-sm bg-light border">Cancel</button>
              </div>
              <div class="px-1">
                <button type="button" (click)="Add()" class="btn btn-sm bl-btn">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show modal-dialog-centered" id="modelconfirm" *ngIf="closepopupflag"
  [hidden]="!closepopupflag" style="padding-right: 4px;display: block;background-color: #5853534d;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header mx-2 p-1">
        <h6 class="modal-title" style="
        font-size: 16px;
        font-weight: 500;" id="relocatedheader">Save Changes</h6>
         <button type="button" class="close" (click)="Closepopup()" style="font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body py-0" style="
      font-size: 16px;
      font-weight: 500;">
        <div class="row py-2 mx-3 pt-3">
          <div class="col-12">
            <label>Do you want to save changes?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex flex-row-reverse">
              <div class="px-1">
                <button type="button" (click)="reset()" class="btn btn-sm bg-light border">Cancel</button>
              </div>
              <div class="px-1">
                <button type="button" (click)="Add()" class="btn btn-sm bl-btn">Save</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


